import { emptyList, emptyObject } from '@constants/empty';

export const getMe = ({ auth }) => auth.me;
export const getProfileInfo =
  (username) =>
  ({ users }) =>
    users.data[username];
export const getProfileStats =
  (username) =>
  ({ users }) =>
    users.profileStats[username] || {};
export const getLearnerMilestones = (state, username) =>
  state.users.learnerMilestones[username] || emptyObject;

export const getLearnerAchievedMileStones = (state, username) =>
  getLearnerMilestones(state, username).achieved || emptyList;

export const getCompletedCourses =
  (username) =>
  ({ paginator }) =>
    paginator.learnerCourses[username];
export const getFeedRowById =
  (feedrowId) =>
  ({ feedrows }) =>
    feedrows.data[feedrowId];
export const getProfileFeed =
  (username) =>
  ({ paginator }) =>
    paginator.profileFeed[username] ?? {};
export const getFollowingList =
  (username) =>
  ({ paginator }) =>
    paginator.learnerFollowing[username];

export const getCourseById =
  (courseUID) =>
  ({ courses }) =>
    courses.data[courseUID];

export const getBatchById =
  (batchUID) =>
  ({ batches }) =>
    batches.data[batchUID];

export const getUserById =
  (username) =>
  ({ users }) =>
    users.data[username];

export const getItemById =
  (itemUID) =>
  ({ items }) =>
    items.data[itemUID];

export const getTopologyById =
  (topologyUID) =>
  ({ topologies }) =>
    topologies.data[topologyUID];

export const isFollowingEducator =
  (username) =>
  ({ users }) =>
    users.data[username.toLowerCase()]?.isFollowing;
